module.exports = __webpack_public_path__ + "img/bugoro_02.a359dae1.png";